import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_DIALED_DIGIT_EXTRACTION_SERVER = '/dipms';

export const SET_DIALED_DIGIT_EXTRACTION_SERVER_LOADING = 'SET_DIALED_DIGIT_EXTRACTION_SERVER_LOADING';
export const GO_TO_DIALED_DIGIT_EXTRACTION_SERVER_CREATE = 'GO_TO_DIALED_DIGIT_EXTRACTION_SERVER_CREATE';
export const GO_TO_DIALED_DIGIT_EXTRACTION_SERVER_EDIT = 'GO_TO_DIALED_DIGIT_EXTRACTION_SERVER_EDIT';
export const GO_TO_DIALED_DIGIT_EXTRACTION_SERVER_VIEW = 'GO_TO_DIALED_DIGIT_EXTRACTION_SERVER_VIEW';
export const GO_TO_DIALED_DIGIT_EXTRACTION_SERVER_COPY = 'GO_TO_DIALED_DIGIT_EXTRACTION_SERVER_COPY';
export const GO_TO_DIALED_DIGIT_EXTRACTION_SERVER_LIST = 'GO_TO_DIALED_DIGIT_EXTRACTION_SERVER_LIST';
export const GET_DIALED_DIGIT_EXTRACTION_SERVER_LIST = 'GET_DIALED_DIGIT_EXTRACTION_SERVER_LIST';
export const GET_DIALED_DIGIT_EXTRACTION_SERVER_LIST_PENDING = 'GET_DIALED_DIGIT_EXTRACTION_SERVER_LIST_PENDING';
export const GET_DIALED_DIGIT_EXTRACTION_SERVER_LIST_FULFILLED = 'GET_DIALED_DIGIT_EXTRACTION_SERVER_LIST_FULFILLED';
export const GET_DIALED_DIGIT_EXTRACTION_SERVER = 'GET_DIALED_DIGIT_EXTRACTION_SERVER';
export const GET_DIALED_DIGIT_EXTRACTION_SERVER_PENDING = 'GET_DIALED_DIGIT_EXTRACTION_SERVER_PENDING';
export const GET_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED = 'GET_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED';
export const CREATE_DIALED_DIGIT_EXTRACTION_SERVER = 'CREATE_DIALED_DIGIT_EXTRACTION_SERVER';
export const CREATE_DIALED_DIGIT_EXTRACTION_SERVER_PENDING = 'CREATE_DIALED_DIGIT_EXTRACTION_SERVER_PENDING';
export const CREATE_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED = 'CREATE_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED';
export const CREATE_DIALED_DIGIT_EXTRACTION_SERVER_REJECTED = 'CREATE_DIALED_DIGIT_EXTRACTION_SERVER_REJECTED';
export const UPDATE_DIALED_DIGIT_EXTRACTION_SERVER = 'UPDATE_DIALED_DIGIT_EXTRACTION_SERVER';
export const UPDATE_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED = 'UPDATE_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED';
export const UPDATE_DIALED_DIGIT_EXTRACTION_SERVER_REJECTED = 'UPDATE_DIALED_DIGIT_EXTRACTION_SERVER_REJECTED';
export const DELETE_DIALED_DIGIT_EXTRACTION_SERVER = 'DELETE_DIALED_DIGIT_EXTRACTION_SERVER';
export const DELETE_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED = 'DELETE_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED';
export const DELETE_DIALED_DIGIT_EXTRACTION_SERVER_REJECTED = 'DELETE_DIALED_DIGIT_EXTRACTION_SERVER_REJECTED';
export const SELECT_DIALED_DIGIT_EXTRACTION_SERVER = 'SELECT_DIALED_DIGIT_EXTRACTION_SERVER';

export enum DialedDigitExtractionServerPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}
export interface DialedDigitExtractionServer {
  id: string
  msid: string
  ipaddr: string
  port: string
  ownnetid: string
  asstate?: string
  reqstate: 'ACTIVE' | 'INACTIVE'
}

export interface DialedDigitExtractionServerState {
  entities: DialedDigitExtractionServer[]
  selected: DialedDigitExtractionServer[],
  single: DialedDigitExtractionServer | null
  createdId: string | null
  ui: DialedDigitExtractionServersUIState
}

export interface DialedDigitExtractionServersUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GoToDialedDigitExtractionServerListAction extends AnyAction {
  type: typeof GO_TO_DIALED_DIGIT_EXTRACTION_SERVER_LIST
}

export interface SetDialedDigitExtractionServerLoadingAction extends AnyAction {
  type: typeof SET_DIALED_DIGIT_EXTRACTION_SERVER_LOADING
  payload: { isLoading: boolean }
}

export interface GetDialedDigitExtractionServerListAction extends AnyAction {
  type: typeof GET_DIALED_DIGIT_EXTRACTION_SERVER_LIST
  payload: AxiosPromise<ServerResponse<DialedDigitExtractionServer>>
}

export interface GetDialedDigitExtractionServerListPendingAction extends AnyAction {
  type: typeof GET_DIALED_DIGIT_EXTRACTION_SERVER_LIST_PENDING
  payload: null
}

export interface GetDialedDigitExtractionServerListFulfilledAction extends AnyAction {
  type: typeof GET_DIALED_DIGIT_EXTRACTION_SERVER_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<DialedDigitExtractionServer>>
}

export interface GetDialedDigitExtractionServerAction extends AnyAction {
  type: typeof GET_DIALED_DIGIT_EXTRACTION_SERVER
  payload: AxiosPromise<ServerResponse<DialedDigitExtractionServer>>
}

export interface GetDialedDigitExtractionServerPendingAction extends AnyAction {
  type: typeof GET_DIALED_DIGIT_EXTRACTION_SERVER_PENDING
  payload: null
}

export interface GetDialedDigitExtractionServerFulfilledAction extends AnyAction {
  type: typeof GET_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED
  payload: AxiosResponse<ServerResponse<DialedDigitExtractionServer>>
}

export interface CreateDialedDigitExtractionServerThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface CreateDialedDigitExtractionServerAction extends AnyAction {
  type: typeof CREATE_DIALED_DIGIT_EXTRACTION_SERVER
  payload: AxiosPromise<ServerResponse<DialedDigitExtractionServer>>
}

export interface CreateDialedDigitExtractionServerPendingAction extends AnyAction {
  type: typeof CREATE_DIALED_DIGIT_EXTRACTION_SERVER_PENDING
  payload: null
}

export interface CreateDialedDigitExtractionServerFulfilledAction extends AnyAction {
  type: typeof CREATE_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED
  payload: AxiosResponse<ServerResponse<DialedDigitExtractionServer>>
}

export interface CreateDialedDigitExtractionServerRejectedAction extends AnyAction {
  type: typeof CREATE_DIALED_DIGIT_EXTRACTION_SERVER_REJECTED
  payload: AxiosResponse<ServerResponse<DialedDigitExtractionServer>>
}

export interface UpdateDialedDigitExtractionServerThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface UpdateDialedDigitExtractionServerAction extends AnyAction {
  type: typeof UPDATE_DIALED_DIGIT_EXTRACTION_SERVER
  payload: AxiosPromise<ServerResponse<DialedDigitExtractionServer>>
}

export interface UpdateDialedDigitExtractionServerFulfilledAction extends AnyAction {
  type: typeof UPDATE_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED
  payload: AxiosResponse<ServerResponse<DialedDigitExtractionServer>>
}

export interface UpdateDialedDigitExtractionServerRejectedAction extends AnyAction {
  type: typeof UPDATE_DIALED_DIGIT_EXTRACTION_SERVER_REJECTED
  payload: AxiosResponse<ServerResponse<DialedDigitExtractionServer>>
}

export interface DeleteDialedDigitExtractionServerThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface DeleteDialedDigitExtractionServerAction extends AnyAction {
  type: typeof DELETE_DIALED_DIGIT_EXTRACTION_SERVER
  payload: AxiosPromise<ServerResponse<DialedDigitExtractionServer>>
}

export interface DeleteDialedDigitExtractionServerFulfilledAction extends AnyAction {
  type: typeof DELETE_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED
  payload: AxiosResponse<ServerResponse<DialedDigitExtractionServer>>
}

export interface DeleteDialedDigitExtractionServerRejectedAction extends AnyAction {
  type: typeof DELETE_DIALED_DIGIT_EXTRACTION_SERVER_REJECTED
  payload: AxiosResponse<ServerResponse<DialedDigitExtractionServer>>
}

export interface SelectDialedDigitExtractionServerAction extends AnyAction {
  type: typeof SELECT_DIALED_DIGIT_EXTRACTION_SERVER
  payload: DialedDigitExtractionServer[]
}

export type DialedDigitExtractionServerActionTypes =
  GoToDialedDigitExtractionServerListAction |
  SetDialedDigitExtractionServerLoadingAction |
  GetDialedDigitExtractionServerListAction |
  GetDialedDigitExtractionServerListPendingAction |
  GetDialedDigitExtractionServerListFulfilledAction |
  GetDialedDigitExtractionServerAction |
  GetDialedDigitExtractionServerPendingAction |
  GetDialedDigitExtractionServerFulfilledAction |
  CreateDialedDigitExtractionServerAction |
  CreateDialedDigitExtractionServerPendingAction |
  CreateDialedDigitExtractionServerFulfilledAction |
  CreateDialedDigitExtractionServerRejectedAction |
  UpdateDialedDigitExtractionServerAction |
  UpdateDialedDigitExtractionServerFulfilledAction |
  UpdateDialedDigitExtractionServerRejectedAction |
  DeleteDialedDigitExtractionServerAction |
  DeleteDialedDigitExtractionServerFulfilledAction |
  DeleteDialedDigitExtractionServerRejectedAction |
  SelectDialedDigitExtractionServerAction;
